"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var splide_1 = __importDefault(require("@splidejs/splide"));
var constants_1 = require("../../data/constants");
var SolrFaceting = /** @class */ (function () {
    function SolrFaceting(element) {
        this.faceting = element === null || element === void 0 ? void 0 : element.querySelector("[".concat(constants_1.DATA_SOLR_FACETING, "]"));
        if (!this.faceting)
            return;
        this.initSplide();
    }
    SolrFaceting.prototype.initSplide = function () {
        var _a;
        this.splide = (_a = this.faceting) === null || _a === void 0 ? void 0 : _a.querySelector("[".concat(constants_1.DATA_SOLR_FACET_SPLIDE, "]"));
        if (!this.splide)
            return;
        var splide = new splide_1.default(this.splide, {
            autoWidth: true,
            arrows: false,
            pagination: false,
            drag: 'free',
        });
        splide.mount();
    };
    return SolrFaceting;
}());
exports.default = SolrFaceting;
